import React, { useState, useEffect } from "react";
import { useHistory, withRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Col, Form, Row, Image, Button, Modal } from "react-bootstrap";
import {
  TextField,
  FormControl,
  Select,
  InputLabel,
  makeStyles,
  MenuItem,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Switch from "react-switch";
import moment from "moment";
import Alert from "react-s-alert";
import CustomSuperAdminNotification from "../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/CustomSuperAdminNotification";
import SuperAdminSmsAdmin from "../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminSmsAdmin";
import SuperAdminCall from "../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminCall";
import NewCountDown from "../../reusableComponents/allPopupReusable/tableNumberPopup/NewCountDown";
import InputNumberFunc from "../../../function/InputNumberFunc";
import { InputCharacterCheck } from "../../../function/InputCharNumCheckFunc";
import DeletePopup from "../../reusableComponents/allPopupReusable/smallPopup/DeletePopup";
import EditWaitTime from "../../reusableComponents/allPopupReusable/tableNumberPopup/EditWaitTime";
import EnterTableNumber from "../../reusableComponents/allPopupReusable/tableNumberPopup/EnterTableNumber";

import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import isEmpty from "../../../store/validation/is-Empty";
// import { update_diner_info_by_admin } from "../../../store/actions/SuperAdminActions/adminPendingActiveDinersAction";
import {
  vendor_dashboard_edit_action,
  vendor_get_available_table_action,
  change_table_status_table_management,
} from "../../../store/actions/dashboardAction/addingAction";
import { sa_vd_reset_diner_request } from "../../../store/actions/SuperAdminVendorDashboardAction/SuperAdminSeatingAction";
import { get_all_vendor_seating_information } from "../../../store/actions/SuperAdminActions/adminSeatingDashboardAllAction";
import {
  get_diner_reservation,
  get_pending_diner,
  inc_seating_count,
  dec_seating_count,
} from "../../../store/actions/dashboardAction/addingAction";
import CallingButtonPopup from "../../reusableComponents/allPopupReusable/CallingButtonPopup";
import ChatWindow from "./seatingDashboard/ChatWindow";
import SendSmsButton from "../../reusableComponents/allPopupReusable/SendSmsButton";
import NotificationButton from "../../reusableComponents/allPopupReusable/NotificationButton";
import ViewDinerSendSmsPopup from "./ViewDinerSendSmsPopup";
import ViewDinerNotificationPopup from "./ViewDinerNotificationPopup";
import Media from "react-media";
import LocationReusable from "../../reusableComponents/allPopupReusable/locationReusablePopup/LocationReusable";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const EditDiner = (props) => {
  //state
  const classes = useStyles();
  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = () => {
    setShowEdit(true);
  };

  /*******************************
   * @DESC Pending Total Wait time
   *******************************/
  const currentTime = new Date();
  var endTime = moment(currentTime).format("YYYY-MM-DDTHH:mm");
  const createdAt = new Date(props?.dataSend?.createdAt);
  var startTime = moment(createdAt).format("YYYY-MM-DDTHH:mm");

  let dateOne = new Date(startTime);
  let dateTwo = new Date(endTime);

  let msDifference = dateTwo - dateOne;
  let minutes = Math.floor(msDifference / 1000 / 60);

  function time_convertPending(minutes) {
    var hours = Math.floor(minutes / 60);
    var nMinutes = minutes % 60;
    return hours + " HH : " + nMinutes + " min";
  }

  /*******************************
   * @DESC Seating Total Wait time
   *******************************/
  const seatedTime = new Date(props?.dataSend?.seatedTime);
  const updatedAt = new Date(props?.dataSend?.updatedAt);
  var endSeatedTime = moment(seatedTime).format("YYYY-MM-DDTHH:mm");
  var startTimeNew = moment(createdAt).format("YYYY-MM-DDTHH:mm");
  var updatedTimeNew = moment(updatedAt).format("YYYY-MM-DDTHH:mm");
  let dateOneSeated = new Date(startTimeNew);
  let dateTwoSeated = new Date(endSeatedTime);
  let dataThreeSeated = new Date(updatedTimeNew);

  let msDifferenceSeated = dateTwoSeated - dateOneSeated;
  let totalUpdatedTime = dataThreeSeated - dateOneSeated;
  let minutesSeated = Math.floor(msDifferenceSeated / 1000 / 60);
  let minutesUpdatedTime = Math.floor(totalUpdatedTime / 1000 / 60);

  function seated_time_difference(minutesSeated) {
    var hours = Math.floor(minutesSeated / 60);
    var nMinutesSeated = minutesSeated % 60;
    return hours + " HH : " + nMinutesSeated + " min";
  }

  function upated_time_difference(minutesUpdatedTime) {
    var hours = Math.floor(minutesUpdatedTime / 60);
    var nMinutesUpdatedTime = minutesUpdatedTime % 60;
    return hours + " HH : " + nMinutesUpdatedTime + " min";
  }

  /**************************
   *@DESC Total Wait Time Diff
   ***************************/
  const updatedTime = new Date(
    props?.dataSend?.wait_time_date || props?.dataSend?.updatedAt
  );
  const currentTimeTwo = new Date().getTime();
  const updatedTimeNewDiff = updatedTime.getTime();
  const waitTime = props?.dataSend?.wait_time * 60 * 1000;
  let updateWaitTime = updatedTimeNewDiff + waitTime;
  let diff = updateWaitTime - currentTimeTwo;

  const vendorSubscriptionInfo = useSelector((state) => {
    return state?.onboarding?.onboard_subscription_details;
  });

  const history = useHistory();
  const [state, setState] = useState({
    isLoading: false,
    number: "",
    name: "",
    highChairHandiCapped: false,
    roomNumber: "",
    tableNumber: "",
    alreadyAddedTableNumber: "",
    specialOcassion: "",
    adultKidsErrors: "",
    handiCapedHighChairErrors: "",
    error: "",
  });
  const [code, setCode] = useState("");
  const [adult, setAdult] = useState(1);
  const [kids, setKids] = useState(0);
  const [handicap, setHandicap] = useState(0);
  const [highchair, setHighchair] = useState(0);
  const [seatingPreference, setSeatingPreference] = useState({
    seatingPreference: "",
  });
  const [checkedBox, setCheckedBox] = useState(false);
  const handleChangeSwitch = (e) => {
    setCheckedBox(!checkedBox);
  };

  useEffect(() => {
    setState({
      number: !isEmpty(props?.dataSend?.user_details?.mobile_number)
        ? props?.dataSend?.user_details?.mobile_number
        : "",
      name: !isEmpty(props?.dataSend?.user_details?.name)
        ? props?.dataSend?.user_details?.name
        : "",
      highChairHandiCapped:
        props?.dataSend?.handicap_chair && props?.dataSend?.high_chair === 0
          ? false
          : true,
      roomNumber: !isEmpty(props?.dataSend?.room_number)
        ? props?.dataSend?.room_number
        : "",
      // tableNumber: !isEmpty(props?.dataSend?.table_number)
      //   ? props?.dataSend?.table_number
      //   : "",
      alreadyAddedTableNumber: !isEmpty(props?.dataSend?.table_number)
        ? props?.dataSend?.table_number
        : "",
      specialOcassion: !isEmpty(props?.dataSend?.occasion)
        ? props?.dataSend?.occasion
        : "",
    });
    setCode(
      !isEmpty(props?.dataSend?.user_details?.country_code)
        ? props?.dataSend?.user_details?.country_code
        : ""
    );
    setAdult(
      !isEmpty(props?.dataSend?.adult_count) ? props?.dataSend?.adult_count : 1
    );
    setKids(
      !isEmpty(props?.dataSend?.kids_count) ? props?.dataSend?.kids_count : 0
    );
    setHandicap(
      !isEmpty(props?.dataSend?.handicap_chair)
        ? props?.dataSend?.handicap_chair
        : 0
    );
    setHighchair(
      !isEmpty(props?.dataSend?.high_chair) ? props?.dataSend?.high_chair : 0
    );
    setSeatingPreference({
      seatingPreference: !isEmpty(
        props?.dataSend?.seating_preference?.length > 0 &&
          props?.dataSend?.seating_preference[0]
      )
        ? props?.dataSend?.seating_preference?.length > 0 &&
          props?.dataSend?.seating_preference[0]
        : "",
    });
    setCheckedBox(
      props?.dataSend?.handicap_chair || props?.dataSend?.high_chair === 0
        ? false
        : true
    );

    if (props?.dataSend?.service_type === "SEATING") {
      let startDate = moment(new Date()).format("YYYY-MM-DD");
      let finalStartDate = startDate + " " + "00:00";
      let endDate = moment(new Date()).format("YYYY-MM-DD");
      let finalendDate = endDate + " " + "23:59";
      props.vendor_get_available_table_action(
        props.auth.user.VendorUser._id,
        finalStartDate,
        finalendDate,
        props.auth.user.accessToken
      );
    } else {
      let reservationDateTime = moment(props?.dataSend?.reservationTime).format(
        "YYYY-MM-DD"
      );
      let finalStartDate = reservationDateTime + " " + "00:00";
      let endDate = reservationDateTime + " " + "23:59";
      props.vendor_get_available_table_action(
        props.auth.user.VendorUser._id,
        finalStartDate,
        endDate,
        props.auth.user.accessToken
      );
    }
  }, []);

  const vendorInfo = useSelector((state) => {
    return state.onboarding.restaurantDetails;
  });
  const seating_area = useSelector((state) => {
    return state?.category?.seating_area;
  });

  const [seatingSelected, setseatingSelected] = useState([]);
  const selected_seating_area = useSelector((state) => {
    return state?.onboarding.onboard_subscription_details?.casual_dining_status
      ?.seating?.general_seating?.seating_areas;
  });
  useEffect(() => {
    if (selected_seating_area && seating_area) {
      let temp = [];
      for (let i = 0; i < seating_area.length; i++) {
        if (selected_seating_area.includes(seating_area[i]._id)) {
          temp.push(seating_area[i]);
        }
      }
      setseatingSelected(temp);
    }
  }, [selected_seating_area, seating_area]);

  const token = useSelector((state) => {
    return state.auth.user;
  });

  const dispatch = useDispatch();

  const handleChangeCode = (event) => {
    setCode(event.target.value);
  };

  const onChange = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
  };
  const onChangeNumber = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    setState({
      ...state,
      [e.target.name]: number,
    });
  };

  const onChangeTableNumber = (e) => {
    setState({
      ...state,
      tableNumber: e.target.value,
    });
  };

  /***************************
   * @DESC on Button Handler
   ***************************/
  const [inc, setInc] = useState(0);
  const onButtonClick = (e, type) => {
    if (seatingPreference.seatingPreference === type) {
      setSeatingPreference({
        ...seatingPreference,
        seatingPreference: "",
      });
      setInc(inc - 1);
    } else {
      setSeatingPreference({
        ...seatingPreference,
        seatingPreference: type,
      });
      setInc(inc + 1);
    }
  };

  const IncrementKidsItem = (e) => {
    e.preventDefault();
    // let errorValue = "You can't add more than maximum number of waitlist people";
    // let totalPeople = adult + kids;
    // if (totalPeople < maximumPeople) {
    //   setState({
    //     ...state,
    //     adultKidsErrors: "",
    //   });
    setState({
      ...state,
      error: "",
    });
    if (adult === 1) {
      if (kids < 100) {
        setKids(kids + 1);
        // setAdult(adult + 1);
      } else {
        setKids(kids + 1);
      }
    } else {
      setKids(kids + 1);
    }
    // } else {
    //   setState({
    //     ...state,
    //     adultKidsErrors: errorValue,
    //   });
    // }
  };

  const IncrementAdultItem = (e) => {
    e.preventDefault();
    setState({
      ...state,
      error: "",
    });
    // let errorValue =
    //   "You can't add more than maximum number of waitlist people";
    // let totalPeople = adult + kids;
    // if (totalPeople < maximumPeople) {
    //   setState({
    //     ...state,
    //     adultKidsErrors: "",
    //   });
    if (adult < 100) {
      setAdult(adult + 1);
    } else {
      return null;
    }
    // } else {
    //   setState({
    //     ...state,
    //     adultKidsErrors: errorValue,
    //   });
    // }
  };

  const IncrementhandicapItem = (e) => {
    e.preventDefault();
    // let errorValue = "You can't add more than adult and kids people";
    // let totalPeople = adult + kids;
    // let totalHighChairHandicapped = highchair + handicap;
    // if (totalPeople > totalHighChairHandicapped) {
    //   setState({
    //     ...state,
    //     handiCapedHighChairErrors: "",
    //   });
    if (handicap < 100) {
      setHandicap(handicap + 1);
    } else {
      return null;
    }
    // } else {
    //   setState({
    //     ...state,
    //     handiCapedHighChairErrors: errorValue,
    //   });
    // }
  };
  const IncrementhighchairItem = (e) => {
    e.preventDefault();
    // let errorValue = "You can't add more than adult and kids people";
    // let totalPeople = adult + kids;
    // let totalHighChairHandicapped = highchair + handicap;
    // if (totalPeople > totalHighChairHandicapped) {
    //   setState({
    //     ...state,
    //     handiCapedHighChairErrors: "",
    //   });
    if (highchair < 100) {
      setHighchair(highchair + 1);
    } else {
      return null;
    }
    // } else {
    //   setState({
    //     ...state,
    //     handiCapedHighChairErrors: errorValue,
    //   });
    // }
  };

  const DecreaseKidsItem = (e) => {
    e.preventDefault();
    setState({
      ...state,
      error: "",
    });
    // setState({
    //   ...state,
    //   adultKidsErrors: "",
    // });
    if (kids > 0) {
      setKids(kids - 1);
    } else {
      return null;
    }
  };

  const DecreaseAdultItem = (e) => {
    e.preventDefault();
    setState({
      ...state,
      error: "",
    });
    if (adult > 1) {
      setAdult(adult - 1);
    } else if (adult <= 1) {
      Alert.error(`<h4>Atleast one adult is required</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      return null;
    }
  };

  const DecreaseHandicapItem = (e) => {
    e.preventDefault();
    // setState({
    //   ...state,
    //   handiCapedHighChairErrors: "",
    // });
    if (handicap > 0) {
      setHandicap(handicap - 1);
    } else {
      return null;
    }
  };
  const DecreaseHighchairItem = (e) => {
    e.preventDefault();
    // setState({
    //   ...state,
    //   handiCapedHighChairErrors: "",
    // });
    if (highchair > 0) {
      setHighchair(highchair - 1);
    } else {
      return null;
    }
  };

  const handleSubmit = (e) => {
    const dinerId = props?.dataSend?._id;
    const vendor_id =
      props?.viewActionPerformBy === "ADMIN"
        ? props?.viewVendorId
        : token.VendorUser._id;
    const tokenData = token.accessToken;
    const formData = {
      kids_count: kids,
      adult_count: adult,
      handicap_chair: handicap,
      high_chair: highchair,
      occasion: state.specialOcassion,
      seating_preference: seatingPreference.seatingPreference,
      room_number: state.roomNumber,
      // table_number: state.tableNumber,
      table_number:
        state.tableNumber !== undefined && state.tableNumber !== ""
          ? state.tableNumber
          : state.alreadyAddedTableNumber,
      user_details: {
        country_code: code,
        deviceToken: "",
        mobile_number: state.number,
        name: state.name,
      },
    };
    if (state.tableNumber !== undefined && state.tableNumber !== "") {
      formData.old_table_number = state.alreadyAddedTableNumber;
    }

    // if (state.tableNumber)
    if (adult <= 0) {
      setState({
        ...state,
        error: "Add atleast one adult",
      });
    } else {
      if (props?.viewActionPerformBy === "ADMIN") {
        dispatch(
          sa_vd_reset_diner_request(
            formData,
            dinerId,
            vendor_id,
            tokenData,
            onCallBackFunc
          )
        );
      } else {
        dispatch(
          vendor_dashboard_edit_action(formData, dinerId, tokenData, onSuccess)
        );
      }
    }
    // dispatch(change_table_status_table_management(
    //   props.subscription_id,
    //   state.tableNumber,
    //   "OCCUPIED",
    //   token,
    //   vendor_id
    // ));
  };

  const onCallBackFunc = () => {
    handleCloseEdit();
  };

  const onSuccess = (e) => {
    const data = { vendor_id: vendorInfo.vendor_id };
    // dispatch(get_all_vendor_seating_information(data));
    if (props?.displayButton === "PENDING") {
      dispatch(get_pending_diner(token.VendorUser._id, token.accessToken));
    } else {
      dispatch(get_diner_reservation(token.VendorUser._id, token.accessToken));
    }
    handleCloseEdit();
  };

  const [highchairHandicappedDisable, setHighchairHandicappedDisable] =
    useState(false);
  // const [highchairShow, setHighchairShow] = useState(false);
  // const [handicappedShow, setHandicappedShow] = useState(false);
  const [onBoardingHighChair, setOnBoardingHighChair] = useState(false);
  const [onBoardingHandicap, setOnBoardingHandicap] = useState(false);
  const [onBoardingRoomNumber, setOnBoardingRoomNumber] = useState(false);
  const [onBoardingKids, setOnBoardingKids] = useState(false);
  const [autoAcceptPaxLimit, setAutoAcceptPaxLimit] = useState(false);
  const [minimumPeople, setMinimumPeople] = useState(0);
  const [maximumPeople, setMaximumPeople] = useState(0);

  useEffect(() => {
    let currentRequest =
      props?.dataSend?.service_type === "SEATING" ? true : false;
    if (vendorSubscriptionInfo?.casual_dining) {
      const generalHighChair =
        vendorSubscriptionInfo?.casual_dining_status?.seating?.general_seating
          ?.highchair;
      const generalHandicapped =
        vendorSubscriptionInfo?.casual_dining_status?.seating?.general_seating
          ?.handicap;
      const generalRoomNumber =
        vendorSubscriptionInfo?.casual_dining_status?.seating?.general_seating
          ?.seating_on_request;
      const generalKids =
        vendorSubscriptionInfo?.casual_dining_status?.seating?.general_seating
          ?.kids_allowed?.value;
      const autoAcceptPaxLimit =
        vendorSubscriptionInfo?.casual_dining_status?.seating?.general_seating
          ?.auto_pax;
      const minPeopleDiner =
        props?.dataSend?.service_type === "SEATING"
          ? vendorSubscriptionInfo?.casual_dining_status?.seating
              ?.walkin_waitlist?.min_person
          : vendorSubscriptionInfo?.casual_dining_status?.seating?.reservation
              ?.minimum_person;
      const maxPeopleDiner =
        props?.dataSend?.service_type === "SEATING"
          ? vendorSubscriptionInfo?.casual_dining_status?.seating
              ?.walkin_waitlist?.auto_accept?.min_person
          : vendorSubscriptionInfo?.casual_dining_status?.seating?.reservation
              ?.auto_accept?.min_person;

      setOnBoardingHighChair(generalHighChair);
      setOnBoardingHandicap(generalHandicapped);
      setOnBoardingRoomNumber(generalRoomNumber);
      setOnBoardingKids(generalKids);
      setAutoAcceptPaxLimit(autoAcceptPaxLimit);
      setMinimumPeople(minPeopleDiner);
      setMaximumPeople(maxPeopleDiner);
      setHighchairHandicappedDisable(
        vendorSubscriptionInfo?.casual_dining_status?.seating?.general_seating
          ?.highchair ||
          vendorSubscriptionInfo?.casual_dining_status?.seating?.general_seating
            ?.handicap
          ? true
          : false
      );
      // setHighchairShow(
      //   vendorSubscriptionInfo?.casual_dining_status?.seating?.general_seating
      //     ?.highchair
      //     ? true
      //     : false
      // );
      // setHandicappedShow(
      //   vendorSubscriptionInfo?.casual_dining_status?.seating?.general_seating
      //     ?.handicap
      //     ? true
      //     : false
      // );
    } else if (vendorSubscriptionInfo?.multi_service_business) {
      const generalHighChair =
        vendorSubscriptionInfo?.multi_service_business_status?.seating
          ?.general_seating?.highchair;
      const generalHandicapped =
        vendorSubscriptionInfo?.multi_service_business_status?.seating
          ?.general_seating?.handicap;
      const generalRoomNumber =
        vendorSubscriptionInfo?.multi_service_business_status?.seating
          ?.general_seating?.seating_on_request;
      const generalKids =
        vendorSubscriptionInfo?.multi_service_business_status?.seating
          ?.general_seating?.kids_allowed?.value;
      const autoAcceptPaxLimit =
        vendorSubscriptionInfo?.multi_service_business_status?.seating
          ?.general_seating?.auto_pax;
      const minPeopleDiner =
        props?.dataSend?.service_type === "SEATING"
          ? vendorSubscriptionInfo?.multi_service_business_status?.seating
              ?.walkin_waitlist?.min_person
          : vendorSubscriptionInfo?.multi_service_business_status?.seating
              ?.reservation?.minimum_person;
      const maxPeopleDiner =
        props?.dataSend?.service_type === "SEATING"
          ? vendorSubscriptionInfo?.multi_service_business_status?.seating
              ?.walkin_waitlist?.auto_accept?.min_person
          : vendorSubscriptionInfo?.multi_service_business_status?.seating
              ?.reservation?.auto_accept?.min_person;

      setOnBoardingHighChair(generalHighChair);
      setOnBoardingHandicap(generalHandicapped);
      setOnBoardingRoomNumber(generalRoomNumber);
      setOnBoardingKids(generalKids);
      setAutoAcceptPaxLimit(autoAcceptPaxLimit);
      setMinimumPeople(minPeopleDiner);
      setMaximumPeople(maxPeopleDiner);
      setHighchairHandicappedDisable(
        vendorSubscriptionInfo?.multi_service_business_status?.seating
          ?.general_seating?.highchair ||
          vendorSubscriptionInfo?.multi_service_business_status?.seating
            ?.general_seating?.handicap
          ? true
          : false
      );
    }
  }, [vendorSubscriptionInfo && vendorSubscriptionInfo]);

  //
  let totalAdultKids = kids + adult;

  const [open, setState1] = useState(false);
  const onCloseModal = () => {
    setState1(!open);
  };

  const [enterTableModal, setEnterTableModal] = useState(false);
  const setTablePopUp = (e) => {
    setEnterTableModal(true);
  };
  const setTablePopUpClose = (e) => {
    setEnterTableModal(false);
  };

  useEffect(() => {
    if (props?.enterTableModal) {
      handleCloseEdit();
    }
  }, [props?.enterTableModal]);

  const [editWaitTimeModel, seteditWaitTimeModel] = useState(false);
  const changeEditWaitTimeModel = () => seteditWaitTimeModel(false);
  const openEditWaitTimeModel = () => seteditWaitTimeModel(true);
  let vendorId = JSON.parse(localStorage.getItem("vendorId"));
  let subscriptionId = JSON.parse(localStorage.getItem("subscriptionId"));

  return (
    <React.Fragment>
      <Button
        variant="link"
        className="enIconBtn mr-3"
        onClick={() => handleShowEdit()}
      >
        <Image
          src={require("../../../assets/images/UserManagement/pencil.svg")}
          alt="Edit"
          title="Edit"
          fluid
        />
      </Button>
      <Modal
        show={showEdit}
        onHide={() => handleCloseEdit()}
        centered
        size="lg"
        style={{zIndex:'1070',paddingLeft:'0',backgroundColor:"#000000bd"}}
      >
        <Modal.Header className="border-0 px-md-4" closeButton>
          <Modal.Title className="f24-700">Edit Diner</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-md-4">
          <Form className="py-4">
            <div
              className={`${
                !props?.origin &&
                `enGrayBorderBox ${
                  props?.dataSend?.service_type === "RESERVATION"
                    ? "enLeftYellowLine"
                    : "enLeftGReenLine"
                }`
              }  mb-4`}
            >
              <Row className="px-3">
                <Col lg={3} md={6} xs={4} className="py-3 mobile-p-1">
                  <div className="f12-500 pb-3">Name/Request Number</div>
                  <div className="d-flex">
                    <div className="order-type-Image">
                      {props?.dataSend?.isWalkIn === true &&
                      props?.dataSend?.service_type === "SEATING" ? (
                        <Image
                          src={require("../../../assets/images/ActionImages/image/walkin.svg")}
                          alt="Order Type"
                          title="Order Type"
                          width="16px"
                        />
                      ) : null ||
                        (props?.dataSend?.isWalkIn === false &&
                          props?.dataSend?.service_type === "SEATING") ? (
                        <Image
                          src={require("../../../assets/images/ActionImages/image/waitlist.svg")}
                          alt="Order Type"
                          title="Order Type"
                          width="16px"
                        />
                      ) : null ||
                        props?.dataSend?.service_type === "RESERVATION" ? (
                        <Image
                          src={require("../../../assets/images/ActionImages/image/reservation.svg")}
                          alt="Order Type"
                          title="Order Type"
                          width="16px"
                        />
                      ) : null}
                      {/* <Image
                        src={require("../../../assets/images/UserManagement/walkin.svg")}
                        alt="View"
                        title="View"
                        width="9px"
                      /> */}
                    </div>
                    <div className="pl-2">
                      <div className="f15-500">
                        {props?.dataSend?.user_details?.name}
                      </div>
                      <div className="f9-400">#{props?.dataSend?.diner_id}</div>
                    </div>
                  </div>
                </Col>
                <Col lg={3} md={6} xs={4} className="py-3 mobile-p-1">
                  <div className="f12-500 pb-3">Total PAX</div>
                  <div className="adult-total-box">
                    <div className="d-flex align-items-center">
                      <p className="f18-700 text-dark mr-2">
                        {props?.dataSend?.adult_count +
                          props?.dataSend?.kids_count}
                      </p>
                      <div className="adult-total-box-two mr-2">
                        {props?.dataSend?.adult_count === 0 ? null : (
                          <div className="d-flex align-items-center justify-content-around mb-2">
                            <div className="adult-total-box-two-insideone">
                              <Image
                                src={require("../../../assets/images/ActionImages/employees.png")}
                                fluid
                                alt="Adult"
                                title="Adult"
                                className="icon-image"
                              />
                            </div>
                            <span className="pl-1">
                              {props?.dataSend?.adult_count}
                            </span>
                          </div>
                        )}
                        {props?.dataSend?.kids_count === 0 ? null : (
                          <div className="d-flex align-items-center justify-content-around">
                            <div className="adult-total-box-two-insideone">
                              <Image
                                src={require("../../../assets/images/ActionImages/children.png")}
                                fluid
                                alt="Children"
                                title="Children"
                                className="icon-image"
                              />
                            </div>
                            <span className="pl-1">
                              {props?.dataSend?.kids_count}
                            </span>
                          </div>
                        )}
                      </div>
                      <div className="adult-total-box-three">
                        {props?.dataSend?.handicap_chair === 0 ? null : (
                          <div className="d-flex align-items-center justify-content-around mb-2">
                            <div className="adult-total-box-three-insideone">
                              <Image
                                src={require("../../../assets/images/ActionImages/highchair.png")}
                                fluid
                                alt="Highchair"
                                title="Highchair"
                                className="icon-image-small"
                              />
                            </div>
                            <span className="pl-1">
                              {props?.dataSend?.handicap_chair}
                            </span>
                          </div>
                        )}
                        {props?.dataSend?.high_chair === 0 ? null : (
                          <div className="d-flex align-items-center justify-content-around">
                            <div className="adult-total-box-three-insideone">
                              <Image
                                src={require("../../../assets/images/ActionImages/wheelchair.png")}
                                fluid
                                alt="Wheel Chair"
                                title="Wheel Chair"
                                className="icon-image-small"
                              />
                            </div>
                            <span className="pl-1">
                              {props?.dataSend?.high_chair}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg={3} md={6} xs={4} className="py-3 mobile-p-1">
                  <div className="f12-500 pb-3">Date / Time / Timer</div>
                  {props?.displayData !== "SUPERADMIN" && (
                    <div className="f18-700 text-red d-flex align-items-center">
                      {props?.displayButton === "PENDING" ||
                      props?.dataSend?.diner_status === "COMPLETED" ||
                      props?.dataSend?.diner_status === "REJECTED" ||
                      props?.dataSend?.diner_status === "CANCELLED" ||
                      props?.dataSend?.diner_status === "SEATED" ? (
                        "00:00:00"
                      ) : (
                        <EditWaitTime
                          allDataProps={props.dataSend._id}
                          noDisplay={
                            <div
                              className="timer-section mr-2"
                              // onClick={openEditWaitTimeModel}
                            >
                              <h4
                                className="f14-700"
                                style={{ color: "#000000",wordBreak:'break-all' }}
                                //timer-count
                              >
                                <NewCountDown waitNew={props?.diff} />
                              </h4>
                            </div>
                          }
                          openFromParent={props.changeEditWaitTimeModel}
                          changeEditWaitTimeModel={
                            props.changeEditWaitTimeModel
                          }
                        />
                      )}
                      {/* {props?.displayData === "SUPERADMIN" ? (
                      ""
                    ) : props?.displayButton === "PENDING" ||
                      props?.dataSend?.diner_status === "COMPLETED" ||
                      props?.dataSend?.diner_status === "REJECTED" ||
                      props?.dataSend?.diner_status === "CANCELLED" ||
                      props?.dataSend?.diner_status === "SEATED" ? (
                      ""
                    ) : (
                      <Button
                        variant="link"
                        className="enIconBtn enSmallIcon ml-1"
                      >
                        <Image
                          src={require("../../../assets/images/UserManagement/pencil.svg")}
                          alt="Edit"
                          title="Edit"
                          fluid
                        />
                      </Button>
                    )} */}
                    </div>
                  )}
                  <p className="f12-400">
                    {props?.dataSend?.service_type === "RESERVATION"
                      ? moment(props?.dataSend?.reservationTime).format(
                          "Do MMM YYYY"
                        )
                      : moment(props?.dataSend?.createdAt).format(
                          "Do MMM YYYY"
                        )}
                  </p>
                  <p className="f12-400">
                    {props?.dataSend?.service_type === "RESERVATION"
                      ? moment(props?.dataSend?.reservationTime).format(
                          "hh:mm A"
                        )
                      : moment(props?.dataSend?.createdAt).format("hh:mm A")}
                  </p>
                </Col>
                <Col lg={3} md={6} xs={4} className="py-3 mobile-p-1">
                  <div className="f12-500 pb-3">Seating Preference</div>
                  <div className="f12-400">
                    {props?.dataSend?.seating_preference.toString()}
                  </div>
                </Col>
              </Row>
              <hr className="m-0" />
              <Row className="px-3">
                <Col lg={3} md={6} xs={4} className="py-3 mobile-p-1">
                  <div className="f12-500 pb-3">Date & Time</div>
                  <p className="f12-400">
                    {props?.dataSend?.service_type === "RESERVATION"
                      ? moment(props?.dataSend?.reservationTime).format(
                          "Do MMM YYYY"
                        )
                      : moment(props?.dataSend?.createdAt).format(
                          "Do MMM YYYY"
                        )}
                  </p>
                  <p className="f12-400">
                    {props?.dataSend?.service_type === "RESERVATION"
                      ? moment(props?.dataSend?.reservationTime).format(
                          "hh:mm A"
                        )
                      : moment(props?.dataSend?.createdAt).format("hh:mm A")}
                  </p>
                </Col>
                <Col lg={3} md={6} xs={4} className="py-3 mobile-p-1">
                  <div className="f12-500 pb-3">
                    Track User
                    <br />
                    Location
                  </div>
                  {/* <div className="ml-4 pl-1">
                    <Image
                      fluid
                      src={require("../../../assets/images/ActionImages/maps-and-flagsred.png")}
                      alt="Location Icon"
                      width="13px"
                      title="Location"
                    />
                  </div> */}
                  <LocationReusable
                    dataSend={props?.dataSend}
                    socket={props?.socket}
                  />
                </Col>
                <Col lg={6} md={6} xs={4} className="py-3 mobile-p-1">
                  <p className="f12-400 text-center">Total Wait time</p>
                  <div className="f10-500 d-flex justify-content-center align-items-center">
                    {props?.displayData === "SUPERADMIN" ? (
                      ""
                    ) : props?.displayButton === "PENDING" ? (
                      <div>
                        <DeletePopup
                          buttonDisplay="smallCancelButton"
                          displayPopup="resonFforCancellation"
                          actionCall={"pendingSide"}
                          buttonText="Reject"
                          bigText="Request Reject"
                          reasonText="Are you sure to Reject ?"
                          dataSend={props?.dataSend?._id}
                        />
                      </div>
                    ) : props?.displayButton === "HISTORY" ? (
                      <div className="">
                        {props?.dataSend?.diner_status === "COMPLETED" ||
                        props?.dataSend?.diner_status === "REJECTED" ? (
                          <DeletePopup
                            buttonDisplay="smallCancelButton"
                            displayPopup="historyReset"
                            buttonText="Reset"
                            bigText="Request Reset"
                            reasonText="Are you sure to Reset ?"
                            dataSend={props?.dataSend}
                          />
                        ) : null ||
                          props?.dataSend?.diner_status === "SEATED" ? (
                          <DeletePopup
                            buttonDisplay="smallCancelButton"
                            displayPopup="historyUnseated"
                            buttonText="Unseat"
                            bigText="Request Unseat"
                            reasonText="Are you sure to Unseat ?"
                            dataSend={props?.dataSend}
                          />
                        ) : null}
                      </div>
                    ) : props?.displayButton === "RESERVATION" ? (
                      props?.dataSend?.diner_status === "SEATED" ? (
                        props?.displayInfo === "SUPERADMIN" ? (
                          ""
                        ) : (
                          <div>
                            <DeletePopup
                              buttonDisplay="smallCancelButton"
                              displayPopup="seatingUnseated"
                              buttonText="Unseat"
                              bigText="Request Unseat"
                              display={true}
                              reasonText="Are you sure to Unseat ?"
                              dataSend={props?.dataSend}
                            />
                          </div>
                        )
                      ) : props?.displayInfo === "SUPERADMIN" ? (
                        ""
                      ) : (
                        <div>
                          {/* <DeletePopup
                            buttonDisplay="smallCancelButton"
                            displayPopup="resonFforCancellation"
                            actionCall={"seatingDashboardSide"}
                            buttonText="Cancel"
                            bigText="Request Cancel"
                            reasonText="Are you sure to Cancel ?"
                            dataSend={props?.dataSend?._id}
                          /> */}
                          <DeletePopup
                            buttonDisplay="smallCancelButton"
                            displayPopup="resonFforCancellation"
                            actionCall={"seatingDashboardSide"}
                            buttonText="Cancel"
                            bigText="Request Cancel"
                            reasonText="Are you sure to Cancel ?"
                            dataSend={props.dataSend._id}
                            actionBy={props.viewActionPerformBy}
                            pathAction="HISTORY"
                            adminSendVendorId={props.viewVendorId}
                            IconButton={require("../../../assets/images/iconButton/crossred.svg")}
                          />
                        </div>
                      )
                    ) : props?.displayButton === "SEATING" ? (
                      props?.dataSend?.diner_status === "SEATED" ? (
                        props?.displayInfo === "SUPERADMIN" ? (
                          ""
                        ) : (
                          <div>
                            <DeletePopup
                              buttonDisplay="smallCancelButton"
                              displayPopup="seatingUnseated"
                              buttonText="Unseat"
                              bigText="Request Unseat"
                              display={true}
                              reasonText="Are you sure to Unseat ?"
                              dataSend={props?.dataSend}
                              subscription_id={props?.subscription_id}
                            />
                          </div>
                        )
                      ) : props?.displayInfo === "SUPERADMIN" ? (
                        ""
                      ) : (
                        <div>
                          <DeletePopup
                            buttonDisplay="smallCancelButton"
                            displayPopup="resonFforCancellation"
                            actionCall={"seatingDashboardSide"}
                            buttonText="Cancel"
                            bigText="Request Cancel"
                            reasonText="Are you sure to Cancel ?"
                            dataSend={props?.dataSend?._id}
                          />
                        </div>
                      )
                    ) : (
                      ""
                    )}
                    <div className="px-2">
                      <div className="enTimesLbl d-flex justify-content-center align-items-center">
                        <Image
                          src={require("../../../assets/images/UserManagement/hourglass.svg")}
                          alt="Edit"
                          title="Edit"
                          width="10px"
                        />
                        <p className="f10-500 text-dark pl-2">
                          {" "}
                          {props?.dataSend?.diner_status === "PENDING" ||
                          props?.dataSend?.diner_status === "NOTSEATED"
                            ? time_convertPending(minutes)
                            : props?.dataSend?.diner_status === "SEATED" ||
                              props?.dataSend?.diner_status === "COMPLETED"
                            ? seated_time_difference(minutesSeated)
                            : props?.dataSend?.diner_status === "REJECTED" ||
                              props?.dataSend?.diner_status === "CANCELLED"
                            ? upated_time_difference(minutesUpdatedTime)
                            : null}
                        </p>
                      </div>
                    </div>
                    {props?.displayData === "SUPERADMIN" ? (
                      ""
                    ) : props?.displayButton === "PENDING" ? (
                      <div>
                        {props?.dataSend?.service_type === "RESERVATION" ? (
                          props?.dataSend?.service_type === "RESERVATION" &&
                          moment(props?.date3).unix() <
                            moment(props?.date1).unix() ? (
                            ""
                          ) : (
                            <DeletePopup
                              buttonDisplay="acceptButtonReservation"
                              buttonText="Accept"
                              bigText="Request Accept"
                              reasonText="Are you sure you want to accept ?"
                              dataSend={props?.dataSend}
                            />
                          )
                        ) : props?.dataSend?.service_type === "SEATING" &&
                          moment(props?.date2).format("DD") <
                            moment(props?.date1).format("DD") ? (
                          ""
                        ) : (
                          <EditWaitTime
                            buttonText="Accept"
                            editButtonStatus="pendingEdit"
                            closedMainModal={props?.onCloseModal}
                            allDataProps={props?.dataSend?._id}
                          />
                        )}
                      </div>
                    ) : props?.displayButton === "HISTORY" ? (
                      <div>
                        {props?.dataSend?.diner_status === "SEATED" ? (
                          <DeletePopup
                            buttonDisplay="smallSaveButton"
                            displayPopup="historyCompleted"
                            buttonText="Complete"
                            bigText="Request Complete"
                            reasonText="Are you sure to Completed ?"
                            dataSend={props?.dataSend}
                          />
                        ) : null}
                      </div>
                    ) : props?.displayButton === "RESERVATION" ? (
                      moment(new Date()).format("YYYY-MM-DD") >=
                      moment(props.dataSend.reservationTime).format(
                        "YYYY-MM-DD"
                      ) ? (
                        props?.dataSend?.diner_status === "SEATED" ? (
                          props?.displayInfo === "SUPERADMIN" ? (
                            ""
                          ) : (
                            <div>
                              <DeletePopup
                                buttonDisplay="smallSaveButton"
                                displayPopup="seatingCompleted"
                                buttonText="Complete"
                                bigText="Request Completed"
                                reasonText="Are you sure to Completed ?"
                                // bigText="Are you sure to Completed ?"
                                dataSend={props?.dataSend}
                              />
                            </div>
                          )
                        ) : props?.displayInfo === "SUPERADMIN" ? (
                          ""
                        ) : (
                          <div>
                            <EnterTableNumber
                              buttonText="Seat"
                              enterTableModal={enterTableModal}
                              closedMainModal={onCloseModal}
                              setTablePopUp={setTablePopUp}
                              setTablePopUpClose={setTablePopUpClose}
                              allDataProps={props.dataSend?._id}
                              wholeDataObj={props.dataSend}
                              IconButton={require("../../../assets/images/iconButton/Nextarrowgreen.svg")}
                            />
                          </div>
                        )
                      ) : null
                    ) : props?.displayButton === "SEATING" ? (
                      props?.dataSend?.diner_status === "SEATED" ? (
                        props?.displayInfo === "SUPERADMIN" ? (
                          ""
                        ) : (
                          <div>
                            <DeletePopup
                              buttonDisplay="seatingCompleted"
                              displayPopup="seatingCompleted"
                              buttonText="Complete"
                              bigText="Request Complete"
                              reasonText="Are you sure to Completed ?"
                              dataSend={props?.dataSend}
                              subscription_id={props?.subscription_id}
                            />
                          </div>
                        )
                      ) : props?.displayInfo === "SUPERADMIN" ? (
                        ""
                      ) : moment().format() >=
                        moment(props?.dataSend?.reservationTime).format() ? (
                        <div>
                          {/* <DeletePopup
                        buttonDisplay="smallSaveButton"
                        displayPopup="SeatedButton"
                        buttonText="Seat"
                        bigText="Request Seated"
                        reasonText="Are you sure to Seated ?"
                        dataSend={props?.dataSend?._id}
                      /> */}

                          {/* <EnterTableNumber
                            buttonText="Seat"
                            closedMainModal={props?.onCloseModal}
                            allDataProps={props?.dataSend?._id}
                            wholeDataObj={props?.dataSend}
                          /> */}
                          <button
                            className="n_button_d_status font_18_m popup-save-button"
                            type="button"
                            onClick={(e) => props?.setEnterTableModalProp(true)}
                          >
                            Seat
                          </button>
                        </div>
                      ) : (
                        <button
                          className="n_button_d_status font_18_m popup-save-button"
                          type="button"
                          onClick={(e) => props?.setEnterTableModalProp(true)}
                        >
                          Seat
                        </button>
                        // <EnterTableNumber
                        //   buttonText="Seat"
                        //   closedMainModal={props?.onCloseModal}
                        //   allDataProps={props?.dataSend?._id}
                        //   wholeDataObj={props?.dataSend}
                        //   // disabled={true}
                        // />
                      )
                    ) : (
                      ""
                    )}
                  </div>
                </Col>
              </Row>
              <hr className="m-0" />
              <Row className="px-3">
                <Media query="(max-width: 991px)">
                  <Col lg={3} md={6} xs={4} className="py-3 mobile-p-1">
                    <div className="d-flex flex-wrap align-items-center py-3 enWidth130">
                      <div className="mb-3">
                        <CallingButtonPopup
                          buttonClass="smallButton"
                          sendData={props?.dataSend}
                        />
                      </div>
                      <div className="mb-3">
                        {/* <ChatWindow
                          data={props?.dinerInfo}
                          text={props?.actionBy}
                        /> */}
                        <ChatWindow
                          data={props?.dataSend}
                          text={props?.actionByData}
                        />
                      </div>
                      <ViewDinerSendSmsPopup
                        mobile_number={
                          props?.dataSend?.user_details?.country_code +
                          props?.dataSend?.user_details?.mobile_number
                        }
                        diner_id={props?.dataSend?._id}
                      />
                      <ViewDinerNotificationPopup
                        buttonClass="smallButton"
                        dataSend={props?.dataSend}
                      />
                    </div>
                  </Col>
                </Media>
                <Col lg={3} md={6} xs={4} className="py-3 mobile-p-1">
                  <div className="f12-500 pb-3">Table / Room No.</div>
                  <div className="f12-400">
                    {props?.dataSend?.table_number === null ||
                    props?.dataSend?.table_number === undefined ||
                    props?.dataSend?.table_number === ""
                      ? ""
                      : `Table No. - ${props?.dataSend?.table_number}`}
                  </div>
                  <div className="f12-400">
                    {props?.dataSend?.room_number === null ||
                    props?.dataSend?.room_number === undefined ||
                    props?.dataSend?.room_number === ""
                      ? ""
                      : `Room No. - ${props?.dataSend?.room_number}`}
                  </div>
                </Col>
                <Col lg={3} md={6} xs={4} className="py-3 mobile-p-1">
                  <div className="f12-500 pb-3">Special Occasion</div>
                  <div className="f12-400">{props?.dataSend?.occasion}</div>
                  {/* <Button variant="link" className="text-red f12-400 p-0">
                    See more
                  </Button> */}
                </Col>
                <Col lg={3} md={6} xs={4} className="py-3 mobile-p-1">
                  <div className="f12-500 pb-3">Status</div>
                  <div className="f13-400">
                    <span className="enYellowDot mr-1"></span>
                    {props?.dataSend?.diner_status}
                  </div>
                </Col>
              </Row>
            </div>
            <Row>
              <Col md={12}>
                <Row>
                  <Col md={6}>
                    <Row>
                      <Col xs={4} className="pr-0">
                        <Form.Group controlId={"code"}>
                          <FormControl variant="outlined" className="w-100">
                            <Select
                              value={code}
                              onChange={handleChangeCode}
                              inputProps={{
                                name: "code",
                              }}
                              disabled={true}
                            >
                              {/* <option value={code}>{code}</option> */}
                              {getCountries().map((country) => (
                                <option
                                  key={country}
                                  value={"+" + getCountryCallingCode(country)}
                                >
                                  {en[country]} (+
                                  {getCountryCallingCode(country)})
                                </option>
                              ))}
                            </Select>
                          </FormControl>
                          {/* <Select
                              value="+91"
                              onChange={handleChangeCode}
                              inputProps={{
                                name: "code",
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              <option value={+91}>+91</option>
                            </Select> */}
                        </Form.Group>
                      </Col>
                      <Col xs={8}>
                        <Form.Group>
                          <TextField
                            id="outlined-basic"
                            label="Phone Number"
                            variant="outlined"
                            className="w-100"
                            defaultValue={state.number.replace(
                              /\d(?=\d{3})/g,
                              "*"
                            )}
                            disabled
                          />
                          {/* <TextField
                            id="outlined-basic"
                            label="Phone Number"
                            variant="outlined"
                            className="w-100"
                            value={state.number}
                            onChange={onChangeNumber}
                            type="number"
                            onKeyDown={InputNumberFunc}
                            inputProps={{
                              name: "number",
                              maxLength: 10,
                            }}
                          /> */}
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <TextField
                        id="outlined-basic"
                        label="Name"
                        variant="outlined"
                        className="w-100"
                        value={state.name}
                        onChange={onChange}
                        type="text"
                        onKeyDown={InputCharacterCheck}
                        inputProps={{
                          name: "name",
                          maxLength: 50,
                        }}
                        disabled={true}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={12} lg={8}>
                    <div className="f16-500 py-3">Party Size</div>
                    <div className="d-flex enPartySize">
                      {onBoardingKids ? (
                        <div className="d-flex pr-3 pb-3">
                          <div className="enKidsIcon">
                            <Image
                              src={require("../../../assets/images/ActionImages/children.png")}
                              alt="View"
                              title="View"
                              width="9px"
                            />
                          </div>
                          <div className="pl-md-2 enPartyPersonEdit">
                            <div className="f14-500 pb-2">Kids</div>
                            <div className="d-flex align-items-center">
                              <Button
                                variant="link"
                                className="p-0"
                                onClick={DecreaseKidsItem}
                              >
                                <Image
                                  src={require("../../../assets/images/UserManagement/minus.svg")}
                                  alt="Minus"
                                  title="Minus"
                                  fluid
                                />
                              </Button>
                              <input
                                placeholder="00"
                                className="enInputValueOnly f12-700"
                                value={kids}
                                readOnly
                              />
                              <Button
                                variant="link"
                                className="p-0"
                                onClick={IncrementKidsItem}
                              >
                                <Image
                                  src={require("../../../assets/images/UserManagement/plus.svg")}
                                  alt="Minus"
                                  title="Minus"
                                  fluid
                                />
                              </Button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      <>
                        <div className="d-flex border-left pl-3 pb-3">
                          <div className="enKidsIcon">
                            <Image
                              src={require("../../../assets/images/ActionImages/employees.png")}
                              alt="View"
                              title="View"
                              width="9px"
                            />
                          </div>
                          <div className="pl-md-2 enPartyPersonEdit">
                            <div className="f14-500 pb-2">Adult</div>
                            <div className="d-flex align-items-center">
                              <Button
                                variant="link"
                                className="p-0"
                                onClick={DecreaseAdultItem}
                              >
                                <Image
                                  src={require("../../../assets/images/UserManagement/minus.svg")}
                                  alt="Minus"
                                  title="Minus"
                                  fluid
                                />
                              </Button>
                              <input
                                placeholder="00"
                                className="enInputValueOnly f12-700"
                                value={adult}
                                readOnly
                              />
                              <Button
                                variant="link"
                                className="p-0"
                                onClick={IncrementAdultItem}
                              >
                                <Image
                                  src={require("../../../assets/images/UserManagement/plus.svg")}
                                  alt="Minus"
                                  title="Minus"
                                  fluid
                                />
                              </Button>
                            </div>
                          </div>
                        </div>
                        <p className="f10-500" style={{ color: "#f85032" }}>
                          {state?.adultKidsErrors}
                          {state?.error}
                        </p>
                      </>
                    </div>
                    {onBoardingHighChair === true ||
                    onBoardingHandicap === true ? (
                      <>
                        <hr />
                        <div className="d-flex align-items-center pb-4">
                          <div className="f16-500">
                            Need Handicap access or a Highchair?
                          </div>
                          <div className="d-flex align-items-center py-4 pl-md-4">
                            <div className="f16-500 mr-2">No</div>
                            <Switch
                              onChange={handleChangeSwitch}
                              checked={
                                onBoardingHighChair === false &&
                                onBoardingHandicap === false
                                  ? false
                                  : true
                              }
                              offColor="#EEEEEE"
                              onColor="#EEEEEE"
                              offHandleColor="#212121"
                              onHandleColor="#59F832"
                              handleDiameter={24}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              height={15}
                              width={41}
                              boxShadow="-2px 0px 5px #0000003B"
                              activeBoxShadow="-2px 0px 5px #0000003B"
                              id="material-switch"
                              disabled={
                                true
                                // highchairHandicappedDisable === false
                                //   ? true
                                //   : false
                              }
                            />
                            <div className="f16-500 ml-2">Yes</div>
                          </div>
                        </div>
                      </>
                    ) : null}
                    {onBoardingHighChair === true ||
                    onBoardingHandicap === true ? (
                      <>
                        <div className="d-flex enPartySize pb-2">
                          {onBoardingHighChair ? (
                            <div className="d-flex pr-3 pb-3">
                              <div className="enKidsIcon">
                                <Image
                                  src={require("../../../assets/images/ActionImages/wheelchair.png")}
                                  alt="View"
                                  title="View"
                                  className="custom"
                                />
                              </div>
                              <div className="pl-md-2 enPartyPersonEdit">
                                <div className="f14-500 pb-2">Handicap</div>
                                <div className="d-flex align-items-center">
                                  <Button
                                    variant="link"
                                    className="p-0"
                                    onClick={DecreaseHandicapItem}
                                  >
                                    <Image
                                      src={require("../../../assets/images/UserManagement/minus.svg")}
                                      alt="Minus"
                                      title="Minus"
                                      fluid
                                    />
                                  </Button>
                                  <input
                                    placeholder="00"
                                    className="enInputValueOnly f12-700"
                                    value={handicap}
                                    readOnly
                                  />
                                  <Button
                                    variant="link"
                                    className="p-0"
                                    onClick={IncrementhandicapItem}
                                  >
                                    <Image
                                      src={require("../../../assets/images/UserManagement/plus.svg")}
                                      alt="Minus"
                                      title="Minus"
                                      fluid
                                    />
                                  </Button>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {onBoardingHandicap ? (
                            <div className="d-flex border-left pl-3 pb-3">
                              <div className="enKidsIcon">
                                <Image
                                  src={require("../../../assets/images/ActionImages/highchair.svg")}
                                  alt="View"
                                  title="View"
                                  className="custom"
                                />
                              </div>
                              <div className="pl-md-2 enPartyPersonEdit">
                                <div className="f14-500 pb-2">Highchair</div>
                                <div className="d-flex align-items-center">
                                  <Button
                                    variant="link"
                                    className="p-0"
                                    onClick={DecreaseHighchairItem}
                                  >
                                    <Image
                                      src={require("../../../assets/images/UserManagement/minus.svg")}
                                      alt="Minus"
                                      title="Minus"
                                      fluid
                                    />
                                  </Button>
                                  <input
                                    placeholder="00"
                                    className="enInputValueOnly f12-700"
                                    value={highchair}
                                    readOnly
                                  />
                                  <Button
                                    variant="link"
                                    className="p-0"
                                    onClick={IncrementhighchairItem}
                                  >
                                    <Image
                                      src={require("../../../assets/images/UserManagement/plus.svg")}
                                      alt="Minus"
                                      title="Minus"
                                      fluid
                                    />
                                  </Button>
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </div>
                        <p
                          className="f10-500 pb-3"
                          style={{ color: "#f85032" }}
                        >
                          {state?.handiCapedHighChairErrors}
                        </p>
                      </>
                    ) : null}
                    <Row>
                      {onBoardingRoomNumber ? (
                        <Col md={5}>
                          <Form.Group>
                            <TextField
                              id="outlined-basic"
                              label="Room No."
                              variant="outlined"
                              className="w-100"
                              value={state.roomNumber}
                              onChange={onChangeNumber}
                              type="number"
                              onKeyDown={InputNumberFunc}
                              inputProps={{
                                name: "roomNumber",
                                maxLength: 3,
                              }}
                            />
                          </Form.Group>
                        </Col>
                      ) : null}
                      {totalAdultKids <= autoAcceptPaxLimit ? (
                        <Col md={5}>
                          <div className="py-3">
                            <h4 className="f14-700">
                              Currently Assigned Table:{" "}
                              <span className="f12-500 ">
                                {props?.dataSend?.table_number}
                              </span>
                            </h4>
                          </div>
                          <FormControl
                            variant="outlined"
                            className={classes.formControl}
                          >
                            <InputLabel htmlFor="outlined-time">
                              Table No.
                            </InputLabel>
                            <Select
                              onChange={onChangeTableNumber}
                              value={state.tableNumber}
                              label="Table No."
                              inputProps={{
                                name: "table_number",
                                id: "outlined-time",
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              <MenuItem value="" disabled selected>
                                Select Table Number
                              </MenuItem>
                              {props.getAvailableTableData &&
                                props.getAvailableTableData?.map(
                                  (data, index) => {
                                    return data.status === "AVAILABLE" ? (
                                      <MenuItem
                                        label="Select a table"
                                        key={index}
                                        value={data.table_number}
                                        name={data.table_number}
                                      >
                                        {data.table_number}
                                      </MenuItem>
                                    ) : null;
                                  }
                                )}
                            </Select>
                          </FormControl>
                          {/* <Form.Group>
                            <TextField
                              id="outlined-basic"
                              label="Table No."
                              variant="outlined"
                              className="w-100"
                              value={state.tableNumber}
                              onChange={onChangeNumber}
                              type="number"
                              onKeyDown={InputNumberFunc}
                              inputProps={{
                                name: "tableNumber",
                                maxLength: 3,
                              }}
                            />
                          </Form.Group> */}
                        </Col>
                      ) : null}
                    </Row>
                    <Row>
                      <Col md={12}>
                        <div className="f16-500 pb-1 pt-3">
                          Seating Preference
                        </div>
                        <div className="f12-400 pb-3">
                          Seating is a subject to availability. Your Preference
                          will be considered.
                        </div>
                      </Col>
                      {/* {seatingSelected &&
                        seatingSelected.map((item, index) => { */}
                      {/* return ( */}
                      <SeatingPreferenceSelect
                        seatingSelected={seatingSelected}
                        seatingPreference={seatingPreference.seatingPreference}
                        onButtonClick={onButtonClick}
                      />
                      {/* );
                        })} */}
                    </Row>
                  </Col>
                  <Col md={12}>
                    <div className="f16-500 pt-3 pb-2">Special Occasion</div>
                    <Form.Group>
                      <TextField
                        id="outlined-multiline-static"
                        multiline
                        rows={5}
                        placeholder="eg. Wedding Anniversary"
                        variant="outlined"
                        className="w-100"
                        value={state.specialOcassion}
                        onChange={onChange}
                        type="text"
                        inputProps={{
                          name: "specialOcassion",
                        }}
                      />
                    </Form.Group>
                    <div className="d-flex align-items-center pt-4">
                      <Button
                        variant="outline-secondary"
                        className="btn150px btn-lg mr-4 px-5"
                        onClick={(e) => handleCloseEdit()}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="danger"
                        className="btn150px btn-lg px-5"
                        onClick={handleSubmit}
                      >
                        Save
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
// export default EditDiner;
EditDiner.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  subscription_id:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details._id,
  onboarding: state.onboarding.restaurantDetails.selected_seating_area,
  getAvailableTableData: state.allDinerDetails.get_vendor_available_table_data,
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, { vendor_get_available_table_action })(
  withRouter(EditDiner)
);
// export default connect(mapStateToProps, null)(withRouter(EditDiner));

const SeatingPreferenceSelect = (props) => {
  const [state, setState] = useState("");
  useState(() => {
    if (!state) {
      setState(props?.seatingPreference);
    }
  }, [props?.seatingPreference]);
  let seatingSelected = props?.seatingSelected || [];
  return (
    <>
      {seatingSelected.map((item) => {
        return (
          <Col
            key={item._id}
            md={4}
            onClick={(e) => {
              setState(item.title);
              props.onButtonClick(e, item.title);
            }}
          >
            <div
              className="enCheckWithText w-100"
              // onChange={(e) => {
              //   setState(item.title);
              //   props.onButtonClick(e, item.title);
              // }}
            >
              <input
                type="radio"
                name="SeatingPreference"
                checked={props?.seatingPreference === item.title ? true : ""}
              />
              <label className="w-100 d-flex align-items-center justify-content-center">
                {/* <Image
  src={require("../../../../../assets/images/UserManagement/chairs.svg")}
  alt="chairs"
  title="chairs"
  className="mr-2"
    /> */}
                {item.title}
              </label>
            </div>
          </Col>
        );
      })}
    </>
  );
};
